import React from "react";
import logo from "../assets/img/Bee.net Logo White & Green@2x.png";
import "../assets/css/header-footer.css";
import { Link } from "react-router-dom";
import Title from "../assets/img/SecureByDesign.png";
import { useLocation } from "react-router-dom";

const Header = () => {
  const location = useLocation();
  const path = location.pathname;

  return (
    <header className="bg-purple1 text-white py-3 d-flex justify-content-between align-items-center ">
      <div className="custom-container">
        {/* Logo + Text */}
        <div className="d-flex align-items-center">
          <a
            href="https://www.bee-net.co.uk/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={logo} alt="BeeNet Logo" className="logo-img me-2" />
          </a>
          <span className="logo-text">
            {(path === "/user/assessment-landing-page" ||
              path === "/user/login-page") && (
              <>
                <span className="pipe me-1"></span>
                <span>Cyber Security Tool Suite</span>
                {/* <span>Cyber Security Management Maturity</span> */}
              </>
            )}
            {(path === "/user/question-page" || path === "/user/result") && (
              <>
                <span className="pipe me-1"></span>
                <span>Cyber Security Management Maturity</span>
              </>
            )}
          </span>
        </div>

        {/* Contact Link */}
        <a
          href="https://www.bee-net.co.uk/contact-us"
          target="_blank"
          rel="noopener noreferrer"
          className="contact1 text-white text-decoration-none py-2"
          style={{
            fontFamily: "Roboto, sans-serif",
            fontWeight: "300",
            fontSize: "20px",
            paddingRight: "10%",
          }}
        >
          Contact Us
        </a>
      </div>
    </header>
  );
};

export default Header;
